import React, { useEffect, useRef } from 'react';
import styles from './ViewFinder.module.less';
import Countdown from './Countdown';

const ViewFinder = ({
  isCountingDown,
  stream,
  status,
}) => {
  const videoRef = useRef(null);

  useEffect(() => {
    if (videoRef.current && stream) {
      videoRef.current.srcObject = stream;
    }
  }, [stream]);

  if (!stream || status === 'stopped') {
    return null;
  }

  if (!['idle', 'recording'].includes(status)) {
    return (
      <section className={styles.vpViewFinderContainer} />
    );
  }

  return (
    <section className={styles.vpViewFinderContainer}>
      {
        isCountingDown
          && <Countdown
            className={styles.vpCountdown}
            countdownTime={3}
          />
      }
      {
        status === 'recording'
          && <div className={styles.vpRecordingIndicatorContainer}>
            <div className={styles.vpRecordingDot} />
            REC
          </div>
      }
      <video
        className={styles.vpViewFinderVideo}
        ref={videoRef}
        autoPlay
      />
    </section>
  );
};

export default ViewFinder;



// WEBPACK FOOTER //
// ./src/components/CameraRecord/ViewFinder.jsx